import { useEffect, useState } from 'react';
import { Input } from '../forms/Input';

interface ICaptchaBasic {
  register?: any;
  errors?: any;
  getValues?: any;
  handleValidate?: any;
  result?: any;
}

export function CaptchaBasic({
  register,
  getValues,
  handleValidate,
}: ICaptchaBasic) {
  const [ask, setAsk] = useState<any>();

  useEffect(() => {
    myQuestion();
  }, []);

  useEffect(() => {
    if (ask) {
      handleValidate(validadeAsk(getValues().captcha, ask.a, ask.op, ask.b));
    }
  });

  function draw(text: string) {
    const canvas: any = document.getElementById('captchaText');
    if (canvas) {
      const ctx = canvas.getContext('2d');
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.textAlign = 'center';
      ctx.font = '18px Arial';
      ctx.fillText(text, 100, 27);
    }
  }

  function myQuestion() {
    const a = Math.floor(Math.random() * 10) + 1;
    const b = Math.floor(Math.random() * 10) + 1;
    const op = ['+'][Math.floor(Math.random() * 1)];

    const question = 'Quanto é ' + a + ' ' + op + ' ' + b + '?';
    draw(question);
    setAsk({ question, a, b, op });
  }

  function validadeAsk(response: any, a: number, op: any, b: number) {
    return response == eval(a + op + b);
  }

  return (
    <>
      <div className="mt-3">
        <div className="d-flex justify-content-center">
          <canvas id="captchaText" height={40} width={200}></canvas>
        </div>
        <Input
          placeholder="Qual o resultado?"
          {...register('captcha', {
            required:
              getValues().email !== 'tester@oqdigital.com' &&
              'Campo obrigatório!', // permissão para o usuario do teste automatizado não precisar fazer o captcha
            onChange: () => {
              if (ask) {
                handleValidate(
                  validadeAsk(getValues().captcha, ask.a, ask.op, ask.b)
                );
              }
            },
          })}
        />
      </div>
    </>
  );
}
